
import { Hero, HeroTitle, HeroPicture, Button } from "./HeroSession.styles"
import HeroPic from "../../../../assets/hero.svg"

const HeroSession = () => {
    return (
      <>
        <Hero>
          <HeroTitle>
            <span>-FINANCE MANAGEMENT</span>
            <h1>We’ve made savings & Investment easier</h1>
            <p>
              We’re not only committed to seeing you achieve your dreams, we
              desire that you build wealth and we can help you with that.
            </p>
            <div>
              <Button to="/product">Get Started</Button>
            </div>
          </HeroTitle>
          <HeroPicture>
            <img src={HeroPic} alt="hero-pic" />
          </HeroPicture>
        </Hero>
      </>
    );
}

export default HeroSession